// extracted by mini-css-extract-plugin
export var content = "index-module--content--sQ15W";
export var contentContainer = "index-module--contentContainer--nKpFS";
export var getInTouchContainer = "index-module--getInTouchContainer--o2pCO";
export var imageContainer = "index-module--imageContainer--+ZCeF";
export var page404Title = "index-module--page404-title--NCkSC";